import { render, staticRenderFns } from "./ModalMobileMenu.vue?vue&type=template&id=5212e2a3"
import script from "./ModalMobileMenu.vue?vue&type=script&lang=js"
export * from "./ModalMobileMenu.vue?vue&type=script&lang=js"
import style0 from "./ModalMobileMenu.vue?vue&type=style&index=0&id=5212e2a3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports